import React from 'react';
export function FrogLogo({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-104">
      {/* Lilypad */}
      <ellipse cx="32" cy="48" rx="28" ry="10" fill="#4A7C59" data-id="element-105" />
      <ellipse cx="32" cy="47" rx="26" ry="9" fill="#5C9A6F" data-id="element-106" />
      {/* Lilypad vein lines */}
      <path d="M32 38 L32 56" stroke="#4A7C59" strokeWidth="0.8" opacity="0.5" data-id="element-107" />
      <path d="M32 47 L18 42" stroke="#4A7C59" strokeWidth="0.6" opacity="0.4" data-id="element-108" />
      <path d="M32 47 L46 42" stroke="#4A7C59" strokeWidth="0.6" opacity="0.4" data-id="element-109" />
      <path d="M32 47 L20 53" stroke="#4A7C59" strokeWidth="0.6" opacity="0.4" data-id="element-110" />
      <path d="M32 47 L44 53" stroke="#4A7C59" strokeWidth="0.6" opacity="0.4" data-id="element-111" />
      {/* Lilypad notch */}
      <path d="M32 47 L28 38 Q32 40 36 38 Z" fill="#F8F7F4" data-id="element-112" />

      {/* Frog body */}
      <ellipse cx="32" cy="38" rx="12" ry="9" fill="#3D8B4F" data-id="element-113" />
      <ellipse cx="32" cy="37" rx="11" ry="8" fill="#4CA85C" data-id="element-114" />

      {/* Frog belly highlight */}
      <ellipse cx="32" cy="39" rx="7" ry="5" fill="#5CBF6C" opacity="0.5" data-id="element-115" />

      {/* Frog head */}
      <ellipse cx="32" cy="28" rx="10" ry="8" fill="#4CA85C" data-id="element-116" />

      {/* Eyes - slightly protruding */}
      <circle cx="25" cy="23" r="5" fill="#4CA85C" data-id="element-117" />
      <circle cx="39" cy="23" r="5" fill="#4CA85C" data-id="element-118" />
      {/* Eye whites */}
      <circle cx="25" cy="22.5" r="3.5" fill="#FFFFFF" data-id="element-119" />
      <circle cx="39" cy="22.5" r="3.5" fill="#FFFFFF" data-id="element-120" />
      {/* Pupils */}
      <circle cx="26" cy="22" r="2" fill="#1E293B" data-id="element-121" />
      <circle cx="40" cy="22" r="2" fill="#1E293B" data-id="element-122" />
      {/* Eye shine */}
      <circle cx="27" cy="21" r="0.8" fill="#FFFFFF" data-id="element-123" />
      <circle cx="41" cy="21" r="0.8" fill="#FFFFFF" data-id="element-124" />

      {/* Smile */}
      <path d="M27 30 Q32 34 37 30" stroke="#3D8B4F" strokeWidth="1.2" fill="none" strokeLinecap="round" data-id="element-125" />

      {/* Nostrils */}
      <circle cx="29" cy="27" r="0.8" fill="#3D8B4F" data-id="element-126" />
      <circle cx="35" cy="27" r="0.8" fill="#3D8B4F" data-id="element-127" />

      {/* Front legs */}
      <path d="M22 40 Q16 44 14 42 Q13 41 16 40 Q18 39 20 38" fill="#4CA85C" data-id="element-128" />
      <path d="M42 40 Q48 44 50 42 Q51 41 48 40 Q46 39 44 38" fill="#4CA85C" data-id="element-129" />

      {/* Front feet/toes */}
      <circle cx="14" cy="41.5" r="1.2" fill="#3D8B4F" data-id="element-130" />
      <circle cx="15.5" cy="40.5" r="1" fill="#3D8B4F" data-id="element-131" />
      <circle cx="50" cy="41.5" r="1.2" fill="#3D8B4F" data-id="element-132" />
      <circle cx="48.5" cy="40.5" r="1" fill="#3D8B4F" data-id="element-133" />

      {/* Small water ripple around lilypad */}
      <ellipse cx="32" cy="48" rx="31" ry="12" stroke="#1C8AD9" strokeWidth="0.5" fill="none" opacity="0.3" data-id="element-134" />
      <ellipse cx="32" cy="48" rx="30" ry="11.5" stroke="#1C8AD9" strokeWidth="0.3" fill="none" opacity="0.15" data-id="element-135" />
    </svg>;
}